var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.columnData)?_c('div',[_vm._v(" "+_vm._s(_vm.columnData.region)+" "),_c('br'),_vm._v(" "+_vm._s(_vm.columnData.country)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }